export class OTA_TotalCharge {
    public rateTotalAmount: number;
    public voucherTotalAmount: number;
    public estimatedTotalAmount: number;
    public estimatedTotalAmountNet: number;
    public estimatedTotalAmountTax: number;
    public currencyCode: string;
    public rentalDays: number;
}